import React from 'react';
import { FiLock } from 'react-icons/fi';
import { usePublicSurveyPlayer } from './usePublicSurveyPlayer';
import SurveyQuestionBlock from '../../../components/surveys/SurveyQuestionBlock';
import SurveyCompletionMessage from '../../../components/surveys/SurveyCompletionMessage';
import SurveyPlayerNav from '../../../components/surveys/SurveyPlayerNav';
import { PageContainer, HeroTitle, HeroSubtitle, Card, StatusPill } from '../../../components/surveys/surveyTheme.styles';

export default function PublicSurveyPlayer() {
  const {
    currentQuestionIndex, data, error, getAnswer, goToNext, goToPrevious, handleSubmit, isReadOnly,
    hasClosingStep, justSubmitted, loading, setAnswerText, setSingleChoice, submitting, toggleMultiChoice, visibleQuestions,
  } = usePublicSurveyPlayer();

  if (loading) return <PageContainer $narrow><p>Loading survey…</p></PageContainer>;
  if (!data) return <PageContainer $narrow><Card style={{ color: 'var(--error-color)' }}>{error || 'This survey link is invalid or has expired'}</Card></PageContainer>;

  if (justSubmitted) {
    return (
      <PageContainer $narrow>
        <SurveyCompletionMessage />
      </PageContainer>
    );
  }

  const isEffectivelyReadOnly = isReadOnly || data.survey_status === 'closed';
  const currentQuestion = visibleQuestions[currentQuestionIndex];

  return (
    <PageContainer $narrow>
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10, flexWrap: 'wrap' }}>
        <HeroTitle $compact>{data.title}</HeroTitle>
        {data.is_anonymous && (
          <StatusPill $tone="anonymous"><FiLock size={11} /> Anonymous</StatusPill>
        )}
      </div>
      {data.description && <HeroSubtitle>{data.description}</HeroSubtitle>}

      <div style={{ marginTop: 20 }}>
        {isReadOnly && <Card style={{ color: 'var(--text-muted)' }}>You've already submitted this survey. Showing your responses below.</Card>}
        {!isReadOnly && data.survey_status === 'closed' && (
          <Card style={{ color: 'var(--error-color)' }}>This survey is closed and no longer accepting responses.</Card>
        )}
        {error && <Card style={{ color: 'var(--error-color)' }}>{error}</Card>}

        {currentQuestion && (
          <SurveyQuestionBlock
            question={currentQuestion}
            answer={getAnswer(currentQuestion.id)}
            isReadOnly={isEffectivelyReadOnly}
            onSingleChoice={setSingleChoice}
            onToggleMulti={toggleMultiChoice}
            onText={setAnswerText}
          />
        )}

        <SurveyPlayerNav
          currentQuestionIndex={currentQuestionIndex}
          totalQuestions={visibleQuestions.length}
          goToPrevious={goToPrevious}
          goToNext={goToNext}
          onSubmit={handleSubmit}
          submitting={submitting}
          isReadOnly={isEffectivelyReadOnly}
          closingMessage={data.closing_message}
          hasClosingStep={hasClosingStep && !isEffectivelyReadOnly}
        />
      </div>
    </PageContainer>
  );
}
